document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-track-click]');
    if (!btn) return;

    window.dataLayer.push({
      event: 'custom_button_click',
      button_name: btn.getAttribute('data-track-click'),
      button_location: btn.getAttribute('data-track-location') || ''
    });
  });
});